import React from 'react';
import ReactDOM from 'react-dom';
import {Link, Redirect} from 'react-router-dom';
import Loader from './Loader';
import AppHeader2 from './AppHeader2';
import ReorderItems from './ReorderItems';
import BottomMenu from './BottomMenu';
import SidebarPanel from './SidebarPanel';

class Reorder extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            LOCATION: this.props.location.pathname,
            LOADING: true, 
            items: [],
            cartEMPTY: 'Y',
            ITEMCOUNT: '',
            CUSTOMER_DET: '',
            page: 1,
            displayLoadMore: ''
        };
    }

    fetchReorderPage(mode,page) {

        let customer = '';
        if(localStorage.getItem('userData'))
            customer = localStorage.getItem('userData');
        
        var id = localStorage.getItem('delCIRCLE');
        var that = this;
        fetch('https://m.donedelivery.in/api/reorder_api.php?mode='+mode+'&id='+id+'&customer='+customer+'&page='+page,{
            mode: 'cors',
            credentials: 'same-origin',
            headers: {
                'Access-Control-Allow-Origin': '*', 
                Accept: 'application/json', 
                'Content-Type': 'application/json',
            },
        }).then(function (response) {
            return response.json();
        }).then(function (result) {
            //console.log(result);
            var ITEMS = result.ITEMS;
            var ITEMCOUNT = result.ITEMCOUNT;
            var CUSTOMER_DET = 'Hi User';
            if(result.CUSTOMER!=='' && result.CUSTOMER!==undefined && result.CUSTOMER!=='undefined')
                CUSTOMER_DET = result.CUSTOMER;

            that.setState({ LOADING:false, items:ITEMS, ITEMCOUNT:ITEMCOUNT, CUSTOMER_DET:CUSTOMER_DET, page: result.page, displayLoadMore: result.LOADMORE });
        });
    }

    fetchSecond(mode,page) {
        var id = localStorage.getItem('delCIRCLE');

        let customer = '';
        if(localStorage.getItem('userData'))
            customer = localStorage.getItem('userData');
       
        var that = this;
        fetch('https://m.donedelivery.in/api/reorder_api.php?mode='+mode+'&id='+id+'&customer='+customer+'&page='+page,{
              mode: 'cors',
              credentials: 'same-origin',
              headers: {
                  'Access-Control-Allow-Origin': '*', 
                  Accept: 'application/json', 
                  'Content-Type': 'application/json',
              },
          }).then(function (response) {
            return response.json();
          }).then(function (result) {

            var ITEMCOUNT = result.ITEMCOUNT;
            var CUSTOMER_DET = 'Hi User';
            if(result.CUSTOMER!=='' && result.CUSTOMER!==undefined && result.CUSTOMER!=='undefined')
                CUSTOMER_DET = result.CUSTOMER;
            
            that.setState({ items: that.state.items.concat(result.ITEMS), page: result.page, displayLoadMore: result.LOADMORE});
        });
    }

    inCartCallBack = () =>{

        let cartEMPTY = 'Y';
        let cart = localStorage.getItem('cartData');
        if(cart !== null && cart!=='{}')
            cartEMPTY = 'N';

        var that = this;
        that.setState({ cartEMPTY:cartEMPTY });
    }
    
    componentWillMount() {
        let mount = $("div").hasClass("modal-backdrop");
        if(mount==true)
        {
            $('body').removeClass('modal-open');
            $(".modal-backdrop").remove();
        }
    }

    componentWillReceiveProps(nextProps) {
        window.location.reload();
        //this.setState({ LOADING:true });
        //this.fetchReorderPage('CATEGORY',nextProps.match.params.id);
    }

    componentDidMount() {
        this.fetchReorderPage('REORDER',this.state.page);
    }

    loadMore = () => {
        //this.state.loading = true;
        this.fetchSecond('REORDER',this.state.page);
    };
  
    render() { 
        let AppHeaderClass = 'appHeader bg-dark text-light';
        let AppHeaderLeft = 'showLINK';
        let AppHeaderLeftLink = '/home';
        let AppHeaderTitle = 'Reorder';
        let AppHeaderRight = '';
        let AppHeaderRightLink = 'SEARCH';
        let AppHeaderSearch = '';

        if(localStorage.getItem('userData')==null)
        {
	        return (<Redirect to={'/home'}/>)
        }
        
        let props = {
            items: this.state.items,
            inCartCallBack: this.inCartCallBack,
        };

        return (
            <div>
                {this.state.LOADING && <Loader />}
                <AppHeader2 AppHeaderClass={AppHeaderClass} AppHeaderLeft={AppHeaderLeft} AppHeaderLeftLink={AppHeaderLeftLink} AppHeaderTitle={AppHeaderTitle} AppHeaderRight={AppHeaderRight} AppHeaderRightLink={AppHeaderRightLink} AppHeaderSearch={AppHeaderSearch} />
                <div id="appCapsule">
                    {this.state.items.length>0 && 
                        <div>
                            <div className="section-title font-size-17 mb-05 text-sdgrey mr-2 ml-2 mt-1"> {this.state.ITEMCOUNT} Item{this.state.ITEMCOUNT>1?'s':''}</div>
                            <div className="section pt-0 pb-2 mt-1">
                                <div className="row">
                                    <ReorderItems {...props} />
                                </div>
                                {this.state.displayLoadMore=='Y' && <p>
                                    <button type="button" style={{'height': '31px'}} onClick={() => this.loadMore()} className="btn newshadowed text-dgrey font-size-11 square btn-danger btn-llg btn-block goBack">Load More</button>
                                </p>}
                            </div>
                        </div>
                    }
                    {this.state.items.length==0 &&
                        <div className="section pt-6" style={{textAlign: 'center'}}>
                            <img src="/assets/img/no-records.png" alt="empty-cart" className="form-image imaged w200" />
                        </div>
                    }
                </div>
                <BottomMenu LOCATION={this.state.LOCATION} />
                {this.state.CUSTOMER_DET && <SidebarPanel CUSTOMER_DET={this.state.CUSTOMER_DET}/>}
            </div>
        );
    }
}
      
export default Reorder;


// WEBPACK FOOTER //
// ./src/components/Reorder.js